<template>
  <div class="p-inputgroup">
    <span class="p-inputgroup-addon">{{ label }} </span>
    <PrimeInputText
      v-model="value"
      :required="required"
      :maxlength="maxlength"
      :disabled="disabled"
      :formatter="formatter"
      @input="oninput"
    />
  </div>
</template>


<script>
export default {
  props: ["modelValue", "label", "required", "maxlength","disabled","formatter"],
  emits: ["update:modelValue"],

  data() {
    return {
      value: null,
    };
  },
  created() {
    this.value = this.modelValue;
  },
   
  methods: {
    oninput() {
      this.$emit("update:modelValue", this.value);
    },
  },
};
</script>
